<script>
  import { emitter } from '@/main.js';
  import { isProxy, toRaw } from 'vue';
  export default {
    name: 'CollectionSort',
    mounted() {
      this.SetCurrentSortName(this.getCurrentSort());
    },
    data() {
      return {
        sortOptions: [
          {
            option: 'relevency',
            name: 'Featured'
          },
          {
            option: 'price_min_to_max',
            name: 'Price: Low to High'
          },
          {
            option: 'price_max_to_min',
            name: 'Price: High to Low'
          },
          {
            option: 'popularity',
            name: 'Most Popular'
          }
        ],
        currentSortName: '',
        url: new URL(window.location.href)
      };
    },
    methods: {
      setActiveSort(optionName, optionId) {
        this.currentSortName = optionName;
        this.toggleSortList();
        emitter.emit('fs-sort-update', optionId);
        this.setUrlParam('sortBy', optionId);
      },
      getActiveClass(optionName) {
        if (optionName === this.currentSortName) {
          return 'popout-list__item popout-list__item--current';
        } else {
          return 'popout-list__item';
        }
      },
      toggleSortList() {
        const sortToggle = document.getElementById('collection-sort-list');
        sortToggle.classList.toggle('popout-list--visible');
      },
      handleFacetUpdate(data) {
        this.facets = data;
        if (isProxy(data)) {
          this.facets = toRaw(data);
        }
      },
      SetCurrentSortName(sortId) {
        this.sortOptions.forEach(item => {
          if (item.option === sortId) {
            this.currentSortName = item.name;
          }
        });
      },
      getCurrentSort() {
        return this.getUrlParam('sortBy') || 'relevency';
      },
      getUrlParam(param) {
        return this.url.searchParams.get(param);
      },
      setUrlParam(paramName, paramValue) {
        const url = new URL(window.location.href);
        url.searchParams.set(paramName, paramValue);
        window.history.replaceState(null, null, url);
      }
    }
  };
</script>

<template>
  <div class="popout--navbar">
    <h2 class="visually-hidden" id="sort-heading">Sort Heading</h2>
    <popout-select>
      <div class="popout" :data-sort-enabled="currentSortName" data-popout="">
        <button type="button" class="popout__toggle gt-p" @click="toggleSortList()" aria-controls="collection-sort-list" aria-describedby="sort-heading" aria-label="Sort">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-sort" viewBox="0 0 10 6">
            <path d="M0 0h10v1H0zm0 2.5h6v1H0zM3 5H0v1h3z" fill-rule="evenodd"></path>
          </svg>
          <span data-sort-button-text="" class="medium-down--hide gt-p__filter-heading" v-html="currentSortName"></span>
          <span class="large-up--hide gt-p__filter-heading">Sort</span>
        </button>
        <ul id="collection-sort-list" class="popout-list" data-popout-list="">
          <li :class="getActiveClass(sortOption.name)" v-for="(sortOption, index) in sortOptions" :key="'sort-' + index">
            <a class="popout-list__option" :data-value="sortOption.option" @click.prevent="setActiveSort(sortOption.name, sortOption.option)">
              <span v-html="sortOption.name"></span>
            </a>
          </li>
        </ul>
      </div>
    </popout-select>
  </div>
</template>

<style lang="scss">
  #fs-collection-sorting {
    .popout-list__item {
      cursor: pointer;
    }
  }
</style>
